import Vue from 'vue';
import { DataService } from '../../data.service';
import { landcoverClasses as legend } from '../../../config/chart-legends';

const chartID = 'getCountyAgricultureDistributionLossesByClass';
/**
 * Tab 5: Agriculture: Distribution Of Wetland Losses By Agriculture
 * getCountyAgricultureDistributionLossesByClass
 */
export class Tab5Chart4 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas[0]);
                this.updateChartData(response.data.LandCoverAtlas[0]);
            }
        })
        this.renderChart();
    }

    updateChartData(response) {
        this.chart.chartOptions.series[0].data = response.data.change;
        this.chart.chartOptions.xAxis.categories = response.categoryAbbr;
        this.chart.infographic.loading = false;
    }

    renderChart() {
        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        title: 'Distribution Of Agriculture Losses By Land Cover',
                        loading: true
                    },
                    animationDuration: 1000,
                    updateArgs: [true, true, { duration: 1000 }],
                    chartOptions: {
                        chart: {
                            type: 'bar',
                            marginTop: 40
                        },
                        colors: ['#804000'],
                        xAxis: {
                            title: {
                                text: 'Land Cover Classes'
                            },
                            categories: ["HID","MID","LID","OSD","WDW","EHW","GRS","DFO","EFO","MFO","SHB","BRN","WTR","PIS"],
                        },
                        yAxis: {
                            title: {
                                text: 'Square Miles'
                            }
                        },
                        tooltip: {
							shared: true,
                            formatter: function () {
								let tooltip = '';
								for(let i=0; i < this.points.length; i++) {
									if(i != 0) {
										tooltip += '<br>-------<br>'
									}
									tooltip += '<b>' + this.points[i].series.name + '</b><br>' + legend[this.x].name + '<br><b>' + this.points[i].y + '</b> square miles';
								}
								return tooltip;
                            }
                        },
                        series: [
                            {
                                name: 'Agriculture lost to',
                                data:
                                    [
                                        0.00, -0.01, -0.01, -0.04, -0.03, -0.24, -0.02, -0.01, -0.07, -0.02, -0.02, -0.01, -0.63, 0.00
                                    ]
                            }
                        ]
                    }
                }
            }
        });
        //end vue component

    }
}
